import GuideMeTitleBar from 'src/components/GuideMeTitleBar';

export const EnterInvoice = {
  title: <GuideMeTitleBar title="Enter Invoice/Credit Memo" />,
  content: (
    <div className="font-semibold text-sm">
      <p>
        Enter the entire Invoice/Credit Memo number from the scanned or printed Invoice/Credit Memo,
        then press "Enter" on your keyboard or click "Next."
      </p>
    </div>
  ),
};
export const SelectInvoice = {
  title: <GuideMeTitleBar title="Choose Invoice/Credit Memo" />,
  content: (
    <div className="font-semibold text-sm">
      <p>Select your Invoice/Credit Memo then click "Next."</p>
      <p>Don't see your Invoice/Credit Memo? Press "Enter" on your keyboard or click "Next."</p>
    </div>
  ),
};
export const EnterPoNumber = {
  title: <GuideMeTitleBar title="Enter PO Number" />,
  content: (
    <div className="font-semibold text-sm">
      <p>Don't have a PO Number? Press "Enter" on your keyboard or click "Next."</p>
    </div>
  ),
};
export const SelectPo = {
  title: <GuideMeTitleBar title="Select PO" />,
  content: (
    <div className="font-semibold text-sm">
      <p>Don't see your PO? Press "Enter" on your keyboard or click "Next."</p>
      <p>Filter the list by entering the Supplier name.</p>
      <p>Filter the list by entering item numbers or descriptions.</p>
    </div>
  ),
};
export const ChooseInvoice = {
  title: <GuideMeTitleBar title="Choose Invoice/Credit Memo" />,
  content: (
    <div className="font-semibold text-sm">
      <p>Don't see your Invoice/Credit Memo? Press "Enter" on your keyboard or click "Next."</p>
    </div>
  ),
};

export const ClosedInvoice = {
  title: 'Cannot Attach to Existing Document',
  content: (
    <div className="font-semibold text-sm p-3">
      <p className="mb-3">This invoice is closed. No further receiving activity may occur.</p>
      <p className="mb-3">
        The most recent invoice record for this PO will be opened for your review.
      </p>
      <p className="mb-3">Please click "OK" to continue</p>
    </div>
  ),
};

export const ClosedPoWithoutReview = {
  title: 'Cannot Create Document',
  content: (
    <div className="font-semibold text-sm">
      This PO is closed, and no further activity is permitted. If you would still like to create a
      document, please go through the Needs Review panel.
    </div>
  ),
};
export const ClosedPo = {
  title: 'Cannot Create Document',
  content: (
    <div className="font-semibold text-sm">
      This PO is closed, and no further activity is permitted.
    </div>
  ),
};

export const GuideMeSteps = [EnterInvoice];
